export default __webpack_public_path__ + "static/media/CNo.48-1.e94dd541.jpg";